module.exports = __webpack_public_path__ + "media/images/badge/special-one_secondary-1493f96c489fa491cc9fad5f0c7f1e9f.png";